/* ==========================================================================
   SPIRO+ MY — Sections batch A behaviors
   Scoped to data-hero-review-strip only. Uses native scroll-snap, so this
   file just wires the optional prev/next buttons to scrollBy().
   ========================================================================== */
(function () {
  'use strict';

  function initReviewStrip(root) {
    var viewport = root.querySelector('[data-hero-review-strip-viewport]');
    var prevBtn = root.querySelector('[data-hero-review-strip-prev]');
    var nextBtn = root.querySelector('[data-hero-review-strip-next]');
    if (!viewport) return;

    function slideWidth() {
      var slide = viewport.querySelector('[data-hero-review-strip-slide]');
      return slide ? slide.getBoundingClientRect().width + 12 : viewport.clientWidth;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hero-review-strip]').forEach(initReviewStrip);
  });
})();
